module.exports = __webpack_public_path__ + "img/articles3.47c6977a.svg";